export default "<tc-generic-list #hotOpportunities id=\"dashboard-hot-opportunities-list\"></tc-generic-list>";